import { createMotionComponent } from "@fluentui/react-components";

export const Grow = createMotionComponent<{ width: number }>(({ width }) => ({
  duration: 1000,
  keyframes: [
    { opacity: 0, maxWidth: `0px` },
    { opacity: 1, maxWidth: `${width}%` },
  ],
  iterations: 1,
}));
